/* @sravni/react-header version 0.2.43 */
import { LINK_ALIAS } from '../types/links.js';
import { generateUrl } from './links.js';

var generateSearchUrl = function (domains) {
    var base = domains.base;
    var origin = typeof window !== 'undefined' ? window.location.origin : undefined;
    return generateUrl('/poisk/', base || origin);
};
var decorateSearchUrlByLinksMap = function (searchUrl, linksMap) {
    var mapper = linksMap[LINK_ALIAS.SEARCH];
    if (!mapper)
        return searchUrl;
    return typeof mapper === 'string' ? mapper : mapper(searchUrl);
};

export { decorateSearchUrlByLinksMap, generateSearchUrl };
//# sourceMappingURL=search.js.map
